/**
 * The email address in a Google ID token, to pre-fill the waitlist after a refused sign-in. It is
 * read without verifying the signature: it only fills in a form field the person can see and
 * change, and nothing is trusted or granted on it. Answers '' when the token cannot be read.
 */
export function emailFromGoogleCredential(credential) {
  try {
    const payload = credential.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const email = JSON.parse(atob(payload)).email;
    return typeof email === 'string' ? email : '';
  } catch {
    return '';
  }
}
